import { render } from "./WellcomeMessageSettingView.vue?vue&type=template&id=9db1b322&scoped=true"
import script from "./WellcomeMessageSettingView.vue?vue&type=script&lang=js"
export * from "./WellcomeMessageSettingView.vue?vue&type=script&lang=js"

import "./WellcomeMessageSettingView.vue?vue&type=style&index=0&id=9db1b322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db1b322"]])

export default __exports__